import "./adminButton.css";

// The one button implementation for the admin app. variant covers visual
// weight/role, size covers density - never add a one-off button class in
// page CSS, extend this instead.
export const AdminButton = ({
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,
  icon,
  iconPosition = "left",
  full = false,
  type = "button",
  className = "",
  children,
  ...rest
}) => {
  const classes = [
    "admin-btn",
    `admin-btn--${variant}`,
    size === "sm" ? "admin-btn--sm" : "",
    full ? "admin-btn--full" : "",
    loading ? "admin-btn--loading" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} className={classes} disabled={disabled || loading} {...rest}>
      {icon && iconPosition === "left" && <span className="admin-btn__icon">{icon}</span>}
      <span className="admin-btn__label">{children}</span>
      {icon && iconPosition === "right" && <span className="admin-btn__icon">{icon}</span>}
    </button>
  );
};
